import {ImmutableObject} from "../../utils/immutableObject";

export class ClientInfos extends ImmutableObject {
    constructor(
        public readonly name?: string,
        public readonly contact?: string,
        public readonly address?: string,
        public readonly city?: string,
        public readonly zipCode?: string,
        public readonly countryIsoCode?: string,
        public readonly phone?: string,
        public readonly email?: string,
        public readonly accountElisId?: string,
        public readonly market?: string,
        public readonly subMarket?: string
    ) {
        super();
    }

}
